/**
 * planesInternet.ts — Planes de internet que se muestran y se comparten en la app.
 *
 * Copiados de https://www.sisnetel.com/#planes. Si cambian los precios en la web,
 * hay que cambiarlos aquí y sacar versión: los usan la pantalla de Promociones
 * Internet y la imagen de planes que se comparte por WhatsApp.
 *
 * OJO: no son los mismos códigos de plan del formulario de Instalaciones
 * (plan_15, plan_16…), que van a n8n. Esos viven en InstalacionesModal.tsx.
 */

export type PlanInternet = {
  id: string;
  nombre: string;
  megas: number;
  precio: number;      // dólares al mes, IVA incluido
  frase: string;
  beneficios: string[];
  etiqueta?: string;
};

export const PLANES_INTERNET: PlanInternet[] = [
  {
    id: '200', nombre: '200 Megas', megas: 200, precio: 16,
    frase: 'El plan de entrada, sin recortes en lo importante',
    beneficios: ['Hasta 8 dispositivos', 'Streaming en HD sin cortes', 'Videollamadas estables', 'Ideal para 2 o 3 personas'],
  },
  {
    id: '400', nombre: '400 Megas', megas: 400, precio: 18,
    frase: 'Dos dólares más y duplicas la velocidad',
    beneficios: ['Hasta 15 dispositivos', 'Varias pantallas en 4K a la vez', 'Teletrabajo y clases en línea', 'Descargas grandes en minutos'],
  },
  {
    id: '700', nombre: '700 Megas', megas: 700, precio: 21, etiqueta: 'El más pedido',
    frase: 'El equilibrio que elige la mayoría',
    beneficios: ['Hasta 25 dispositivos', 'Gaming en línea con baja latencia', 'Casa llena sin pelearse por el wifi', 'Subidas rápidas para creadores'],
  },
  {
    id: '1000', nombre: '1 Giga', megas: 1000, precio: 25,
    frase: 'Toda la fibra, sin límites artificiales',
    beneficios: ['Dispositivos ilimitados', 'Un giga completo de bajada', 'Casa inteligente y cámaras 24/7', 'Perfecto para oficinas pequeñas'],
  },
];

export const MEGAS_MAXIMO = Math.max(...PLANES_INTERNET.map(p => p.megas));
export const PRECIO_MINIMO = Math.min(...PLANES_INTERNET.map(p => p.precio));

/** Lo que traen todos los planes, según la web. */
export const INCLUYE_TODOS = [
  'IVA incluido',
  'Sin costo de instalación',
  'Instalación en 24-48 h',
  'Router Wi-Fi en comodato',
  'Fibra hasta tu casa (FTTH)',
  'IPv6 nativo',
  'Seguridad y filtrado',
  'Soporte técnico local',
];

// Mismo WhatsApp que publica la web. Solo dígitos, que es lo que pide wa.me.
export const WHATSAPP_VENTAS = '593986031015';
export const WHATSAPP_VENTAS_VISIBLE = '+593 98 603 1015';
export const SITIO_WEB = 'www.sisnetel.com';
